module.exports = __webpack_public_path__ + "img/21.c7e16887.jpg";